<template>
  <div class="row">
    <div class="col-12 col-md-8">
      <input type="checkbox" v-model="ckbRemoveMedia" :name="input_file_name+'_removeMedia'" style="display: none">
    <input :name="input_file_name" type='file' :id="'imgInp'+input_file_name" v-on:change="loadFile"
           style="display: none" ref="fileInput"/>
    <img :id="'imgSrc'+input_file_name" class="img-fluid" style="border: 1px solid #ddd; width: 300px; height: 150px; object-fit: cover; background-color: #eee;">
    <video :id="'vdSrc'+input_file_name" controls class="img-fluid" style="visibility: hidden; display: none;">
      <source id="preLoadVideo">
      {{ __("errors.uploadFile.browser_not_support_video_tag") }}
    </video>
    </div>

   <div class="col-12 col-md-4">
    <div class="row">
      <div class="col-md-6">
        <button id="btnOk" type="button" class="btn btn--blue" @click="$refs.fileInput.click()">{{
            __("misc.upload")
          }}
        </button>
      </div>
      <div class="col-md-6 text-right">
        <button id="rmvBtn" type="button" class="btn btn--red" @click="removeFile">{{ __("misc.remove") }}</button>
      </div>
    </div>
   </div>
  </div>
</template>

<script>


export default {
  mounted() {
    if (this.input_file_url != null) {
      if (this.input_file_type_image) {
        $("#imgSrc" + this.input_file_name).css("visibility", "visible");
        $("#imgSrc" + this.input_file_name).css("display", "inline");
        $("#imgSrc" + this.input_file_name).attr('src', this.input_file_url);
      } else {
        $("#vdSrc" + this.input_file_name).css("visibility", "visible");
        $("#vdSrc" + this.input_file_name).css("display", "inline");
        $("#vdSrc" + this.input_file_name).attr('src', this.input_file_url);
      }
    }
  },
  data() {
    return {
      ckbRemoveMedia: false
    }
  },
  methods: {
    loadFile: function () {
      const file = $("#imgInp" + this.input_file_name).prop('files')[0];
      if (file) {
        if (file.type.includes("image")) {
          $("#imgSrc" + this.input_file_name).css("visibility", "visible");
          $("#imgSrc" + this.input_file_name).css("display", "inline");
          $("#imgSrc" + this.input_file_name).attr('src', URL.createObjectURL(file));

          $("#vdSrc" + this.input_file_name).css("visibility", "none");
          $("#vdSrc" + this.input_file_name).css("display", "hidden");
          $("#vdSrc" + this.input_file_name).attr('src', null);

          this.ckbRemoveMedia = false;
        }
        if (file.type.includes("video")) {

          $("#imgSrc" + this.input_file_name).css("visibility", "none");
          $("#imgSrc" + this.input_file_name).css("display", "hidden");
          $("#imgSrc" + this.input_file_name).attr('src', null);

          $("#vdSrc" + this.input_file_name).css("visibility", "visible");
          $("#vdSrc" + this.input_file_name).css("display", "inline");
          $("#vdSrc" + this.input_file_name).attr('src', URL.createObjectURL(file));

          this.ckbRemoveMedia = false;
        } else
          console.log("file sbagliato");
      }
    },
    removeFile: function () {

      $("#vdSrc" + this.input_file_name).css("visibility", "hidden");
      $("#vdSrc" + this.input_file_name).css("display", "none");
      $("#vdSrc" + this.input_file_name).attr('src', null);

      $("#imgSrc" + this.input_file_name).css("visibility", "none");
      $("#imgSrc" + this.input_file_name).css("display", "hidden");
      $("#imgSrc" + this.input_file_name).attr('src', null);

      this.ckbRemoveMedia = true;
    },
  },
  props: {
    input_file_name: {
      type: String,
      required: true
    },
    input_file_type_image: {
      type: Boolean
    },
    input_file_url: {
      typer: String
    }
  }
}
</script>